import { MouseEvent as ReactMouseEvent } from 'react';

import { useTranslation } from 'libs/i18n';
import { ROUTES, useNavigate } from 'libs/navigation';
import { Tab, Tabs } from 'libs/ui';

export interface PersonAndLegalClientsToggleButtonProps {
  value?: 'legal' | 'person';

  onChange?: (
    event: ReactMouseEvent<HTMLElement, MouseEvent>,
    value: 'legal' | 'person'
  ) => void;
}

export const PersonAndLegalClientsToggleButton = ({
  value,
  onChange,
}: PersonAndLegalClientsToggleButtonProps) => {
  const { t } = useTranslation();

  const { navigate } = useNavigate();

  const handleChange = (
    event: ReactMouseEvent<HTMLElement, MouseEvent>,
    value: 'legal' | 'person'
  ) => {
    if (onChange) {
      onChange(event, value);
    } else if (value === 'legal') {
      navigate(ROUTES.clients.legalClients.fullPath, {}, { event });
    } else {
      navigate(ROUTES.clients.personClients.fullPath, {}, { event });
    }
  };

  return (
    <Tabs value={value}>
      <Tab
        label={t('client.clients.toggleButtons.person')}
        value="person"
        onClick={(e) => handleChange?.(e, 'person')}
      />
      <Tab
        label={t('client.clients.toggleButtons.legal')}
        value="legal"
        onClick={(e) => handleChange?.(e, 'legal')}
      />
    </Tabs>
  );
};
